
import TtamDestinationTypeSelectorTab from './destination-type-selector-tab/index.vue';

export default {
  TtamDestinationTypeSelectorTab,
};
